import { FC, createContext, useContext, useState } from "react";

interface ShowProviderProps {
  children: React.ReactNode;
}

export const ShowContext = createContext({
  isShow: false,
  setShow: (_value: boolean) => {},
});

const ShowProvider: FC<ShowProviderProps> = ({ children }) => {
  const [isShow, setShow] = useState(false);
  return (
    <ShowContext.Provider value={{ isShow, setShow }}>
      {children}
    </ShowContext.Provider>
  );
};

export function useShow() {
  const context = useContext(ShowContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
}

export default ShowProvider;